const baseStyle = () => ({
  _container: {
    flex: 1,
    flexDirection: 'row',
  },

  _icon: {
    color: 'gray.300',
    mr: '3',
    size: 'lg',
  },
  _iconActive: {
    color: 'yellow.500',
  },
});

export default {
  baseStyle,
};
